export const SET_WIZARDS = 'SET_WIZARDS'
export const RESET_CONFIGURATOR_WIZARD = 'RESET_CONFIGURATOR_WIZARD'
export const RESET_TRADEIN_WIZARD = 'RESET_TRADEIN_WIZARD'
export const RESET_STOCK_WIZARD = 'RESET_STOCK_WIZARD'

export const setWizards = wizards => ({
  type: SET_WIZARDS,
  wizards
})

export const resetTradeInWizard = tradeInConfig => ({
  type: RESET_TRADEIN_WIZARD,
  tradeInConfig
})

export const resetConfiguratorWizard = () => ({
  type: RESET_CONFIGURATOR_WIZARD
})

export const resetStockWizard = () => ({
  type: RESET_STOCK_WIZARD
})
